import { call, put, takeEvery } from "redux-saga/effects";
import { keHoachTuanApi } from "../../../api/ke-hoach/keHoachTuanApi";
import { IKeHoachTuanCreateRequest } from "../../../model/request/ke-hoach/IKeHoachTuanCreateRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eKeHoachTuanActionIds, IKeHoachTuanActionTypes } from "../../action-types/ke-hoach/IKeHoachTuanActions";
import { rootActions } from "../../actions/rootActions";

export function* keHoachTuanSaga(): any {
  yield takeEvery(eKeHoachTuanActionIds.LOAD_START, loadWorker);
  yield takeEvery(eKeHoachTuanActionIds.SAVE_START, saveWorker);
}

function* loadWorker(action: IKeHoachTuanActionTypes): any {
  const res: IBaseRespone = yield call(keHoachTuanApi.SelectByKeHoachNam, action.payload as number);
  if (res.is_success) {
    yield put(rootActions.keHoach.keHoachTuan.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.keHoach.keHoachTuan.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* saveWorker(action: IKeHoachTuanActionTypes): any {
  const res: IBaseRespone = yield call(keHoachTuanApi.CreateByNam, action.payload as IKeHoachTuanCreateRequest);
  if (res.is_success) {
    yield put(rootActions.keHoach.keHoachTuan.SAVE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.keHoach.keHoachTuan.SAVE_ERROR(res.message ?? "Có lỗi")
    );
  }
}
